<template>
  <tr
    :class="{
      'table__tr--background': validateIsInserted(),
      'table__tr--red': invoice.ESTAT === 'VENCIDO',
    }"
  >
    <!-- Document Number -->
    <td>
      <div class="d-flex align-items-center justify-content-center">
        {{ invoice.BELNR }}
        <special-order-type-icon :order="invoice.AUART" />
      </div>
    </td>
    <!-- Document Type -->
    <td>
      <div class="d-flex align-items-center">
        <div v-if="!validateIsInserted()" class="icon-toggle-container">
          <v-icon
            v-if="invoice.DETFAC !== undefined && invoice.DETFAC.length > 0"
            small
            color="#5600e8"
            @click="$emit('actionButton')"
          >
            {{ invoice.isOpen ? 'mdi-minus-circle' : 'mdi-plus-circle' }}
          </v-icon>
        </div>
        <span class="w-100">{{ invoice.TIPO }}</span>
        <div class="badge-container">
          <span v-if="invoice.AUGRU" class="badge rounded-pill badge-augru">{{
            invoice.AUGRU
          }}</span>
        </div>
      </div>
    </td>
    <!-- Downloads -->
    <td>
      <div class="d-flex justify-content-center">
        <div class="d-flex align-items-start download-icons-container">
          <download-invoice-tooltip :invoice-id="invoice.BELNR" :type="1" />

          <download-invoice-tooltip :invoice-id="invoice.BELNR" :type="2" />

          <template v-if="!invoice.inserted">
            <download-invoice-tooltip
              v-if="invoice.ACUSEDOC64 == '1'"
              :invoice-id="invoice.BELNR"
              :type="4"
            />

            <download-invoice-tooltip
              v-if="invoice.ACUSEFAC64 == '1'"
              :invoice-id="invoice.BELNR"
              :type="5"
            />
          </template>
        </div>
      </div>
    </td>
    <!-- Purchase Order -->
    <td>
      {{ !validateIsInserted() ? invoice.BSTKD : '-' }}
    </td>
    <!-- Document Date -->
    <td>{{ invoice.BUDAT }}</td>
    <!-- Delivery date -->
    <td>{{ invoice.FACUS }}</td>
    <!-- Expiration date -->
    <td>{{ !validateIsInserted() ? invoice.FVENC : '-' }}</td>
    <!-- Days Expired -->
    <td>{{ !validateIsInserted() ? invoice.DMORA : '-' }}</td>
    <!-- Amount -->
    <td>${{ invoice.DMBTR | formatCurrency }}</td>
    <!-- Amount Not Expire -->
    <td>
      {{
        parseFloat(invoice.DMORA) == 0
          ? `$${formatCurrency(invoice.DMBTR)}`
          : ''
      }}
    </td>
    <!-- Amount Expired -->
    <td>
      {{
        parseFloat(invoice.DMORA) > 0 ? `$${formatCurrency(invoice.DMBTR)}` : ''
      }}
    </td>
  </tr>
</template>

<script>
  import axios from '@/plugins/axios';
  import DownloadInvoiceTooltip from '@/components/DownloadInvoiceTooltip.vue';
  import SpecialOrderTypeIcon from '@/components/SpecialOrderTypeIcon.vue';

  export default {
    components: { DownloadInvoiceTooltip, SpecialOrderTypeIcon },
    props: {
      invoice: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        image: '',
      };
    },
    methods: {
      validateIsInserted() {
        return this.invoice.inserted;
      },
      async getPDFXMLInvoice(invoice, type) {
        try {
          const response = await axios.post('/InvoicePDFXML', {
            invoice: invoice,
            type: type,
          });

          this.openDocument(response.data);
        } catch {
          this.$toast.error('Ocurrió un error al abrir el documento');
        }
      },
      async getAcuseInvoice(invoice, type) {
        try {
          const { data } = await axios.get('/invoiceAcuse', {
            params: { invoice },
          });
          const acuse = data?.data;

          const imageMap = {
            3: acuse?.ACUSEDOC,
            4: acuse?.ACUSEDOC64,
            5: acuse?.ACUSEFAC64,
          };

          const image = imageMap[type] || '';
          this.openDocument(image);
        } catch {
          this.$toast.error('Ocurrió un error al abrir el documento');
        }
      },
      openDocument(document) {
        if (document) {
          window.open(document, '_blank');
        } else {
          this.$toast.warning(
            'No se encontró ningún documento disponible para esta factura.'
          );
        }
      },
      formatCurrency(value) {
        return this.$options.filters.formatCurrency(value);
      },
    },
  };
</script>

<style scoped>
  .table__tr--red {
    color: red;
  }

  .table__tr--background td {
    background: #f2f2f2;
  }

  .download-icons-container {
    width: 70px;
  }

  .icon-toggle-container {
    min-width: 30px;
  }

  .badge-container {
    min-width: 32px;
  }

  .badge-augru {
    background: #306b75;
  }
</style>
